export default function CustomerPanelLayout(prop) {
  return (
    <div className="d-flex pt-5" style={{ backgroundColor: "#DBF0EE" }}>
      {prop.children}
    </div>
  );
}
